export enum EnquiryProductCategoryEnum{
    Ring = 'Ring',
    Skewers = 'Skewers',
    Pouch = 'Pouch',
    Platter = 'Platter',
    Nobashi = 'Nobashi'
}